import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';
import LottieAnimation from './lottieAnimation';
import { WxLaunchHack } from '@ifeng-fe/three_terminal/es/mobile/wxLaunchHack/dynamic';
import { h5PageCount } from 'ThreeTerminal_utils';
import Chip from 'Chip';
import { cookie } from '@ifeng-fe/ui_base';

class ListenNews extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        isPause: true,
        isInit: false,
        speedText: ['倍速1.0x', '倍速1.5x', '倍速2.0x'],
        speedIndex: 0,
        playText: ['听新闻', '继续播', '播放中'],
        loadAnimation: null,
        wxLaunchHackData: {},
        grayName: '', // click playing
        isShowPopup: false,
    }

    loadAnimation = null;
    audioLoad = null;
    audioDuration = 0;
    isOnceClick = false;

    isShowPopupHandle = (value) => {
        this.setState({
            isShowPopup: value
        });
    }

    callAppGrayHandle = () => {
        const { content } = this.props;
        let cutoffGrayNum = cookie.get('cutoffGrayNum');

        if (!cutoffGrayNum) {
            cutoffGrayNum = Math.floor(Math.random() * 100) + 1;

            cookie.set(
                'cutoffGrayNum',
                cutoffGrayNum,
                '',
                '',
                new Date(new Date().toLocaleDateString()).getTime() + 24 * 30 * 60 * 60 * 1000 - new Date().getTime(),
            );
        }
        // grayPercentage

        if (parseInt(cutoffGrayNum) <= content?.grayPercentage) {
            this.setState({
                wxLaunchHackData: {
                    callAppConfig: {
                        pid: content._id,
                        kind: 'inter_txx01',
                        noKindFrom: 1,
                        download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7278121107522297856',
                        downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9185'
                    },
                    callAppClick: () => {
                        h5PageCount([
                            {
                                behavior: 'action',
                                type: 'listennews_1',
                                other: {
                                    id: `ucms_${content.base62Id}`,
                                    url: encodeURIComponent(location.href),
                                },
                            },
                        ]);
                    }
                },
                grayName: 'click'
            });
        } else {
            this.setState({
                wxLaunchHackData: {
                    callAppConfig: {
                        pid: content._id,
                        kind: 'inter_txx02',
                        noKindFrom: 1,
                        download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7278121223486413824',
                        downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9186'
                    },
                    callAppClick: () => {
                        h5PageCount([
                            {
                                behavior: 'action',
                                type: 'listennews_y',
                                other: {
                                    id: `ucms_${content.base62Id}`,
                                    url: encodeURIComponent(location.href),
                                },
                            },
                        ]);
                    }
                },
                grayName: 'playing'
            });
        }
    }

    audioInit = () => {
        const { content } = this.props;

        this.audioLoad = new Audio(content.audioPlayUrl);
        this.audioLoad.addEventListener('loadedmetadata', () => {
            this.audioDuration = parseInt(this.audioLoad.duration);

            this.audioLoad.addEventListener('timeupdate', () => {
                if (this.audioLoad.currentTime >= this.audioDuration / 3 && content.isOpenCallUp) {
                    this.audioLoad.pause();
                    this.loadAnimation.pause();
                    this.setState({
                        isPause: true,
                        isShowPopup: true
                    });
                }
            });
        });

        this.audioLoad.addEventListener('pause', () => {
            this.loadAnimation.pause();
        });

        this.audioLoad.addEventListener('ended', () => {
            this.loadAnimation.pause();
            this.setState({
                isPause: true,
            });
        });
    }

    componentDidMount() {
        this.callAppGrayHandle();     
        this.audioInit();
    }

    audioHandle = () => {
        if (this.state.grayName === 'click' && this.props.content.isOpenCallUp === true) return;
        if (this.loadAnimation && this.state.isPause) {
            this.loadAnimation.play();
        } else if (this.loadAnimation && !this.state.isPause) {
            this.loadAnimation.pause();
        }

        if (!this.isOnceClick) {
            this.isOnceClick = true;
            h5PageCount([
                {
                    behavior: 'action',
                    type: 'listennews_2',
                    other: {
                        id: `ucms_${this.props.content.base62Id}`,
                        url: encodeURIComponent(location.href),
                    },
                },
            ]);
        }

        this.setState({
            isPause: !this.state.isPause,
            isInit: true
        }, () => {
            if (this.state.isPause) {
                this.audioLoad.pause();
            } else {
                this.audioLoad.play();
            }
        });
    }

    getLoadAnimation = (obj) => {
        this.loadAnimation = obj;
    };

    controlSpeed = (event) => {
        event.stopPropagation();
        let speedIndex = 1;

        switch (this.state.speedIndex) {
            case 0:
                speedIndex = 1;
                this.audioLoad.playbackRate = 1.5;
                break;
            case 1:
                speedIndex = 2;
                this.audioLoad.playbackRate = 2.0;
                break;
            case 2:
                speedIndex = 0;
                this.audioLoad.playbackRate = 1.0;
                break;
            default:
                speedIndex = 1;
                this.audioLoad.playbackRate = 1.0;
                break;
        }

        this.setState({
            speedIndex
        });    

    }

    render() {
        const { content } = this.props;
        const { grayName, isShowPopup, isPause, isInit, speedIndex, speedText, playText, wxLaunchHackData } = this.state;

        return (
            content?.audioPlayUrl && content?.isOpenListen ? 
                        <Chip
                            id="260897"
                            type="struct"
                            title="听新闻"
                            groupName="听新闻"
                        >
                        <div>
                            <div className={styles.listenNews} onClick={this.audioHandle}>
                                <div className={`${isPause ? styles.playBtn : styles.pauseBtn}`} />
                                {isInit ? 
                                    <> 
                                        <LottieAnimation getLoadAnimation={this.getLoadAnimation} />
                                        <div className={styles.speed} onClick={this.controlSpeed}>
                                            {speedText[speedIndex]}
                                        </div>
                                    </> :
                                    <div className={styles.info}>
                                        点击收听本新闻
                                    </div>
                                }
                                <div className={styles.line} />
                                <div className={styles.tip} >
                                    {!isInit && playText[0]}
                                    {isInit && isPause && playText[1]}
                                    {isInit && !isPause && playText[2]}
                                </div>
                                {wxLaunchHackData?.callAppConfig && content.isOpenCallUp && grayName === 'click' && (
                                    <WxLaunchHack content={wxLaunchHackData} />
                                )}
                            </div>
                            {isShowPopup && <div className={styles.popupBox}>
                                <div className={styles.popup}>
                                    <div className={styles.popupTip}>
                                        前往凤凰新闻App获得更<br />多新鲜有料新闻播报
                                    </div>
                                    <div className={styles.popupButton}>
                                        <div className={styles.popupButtonL} onClick={() => { this.isShowPopupHandle(false); }}>
                                            取消
                                        </div>
                                        <div className={styles.popupButtonR}>
                                            确定
                                            {wxLaunchHackData?.callAppConfig && content.isOpenCallUp && (
                                                <WxLaunchHack content={wxLaunchHackData} />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>}
                        </div>
                    </Chip>
                : null
        );
    }
}

export default errorBoundary(ListenNews);
